import { getRecordList, getMediaUrl } from '@src/utils/media-data';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { getOmniData, Ids } from '@src/services/omni-api';
import Video from '@src/components/video';

class Part3Store extends BaseStore {
  @observable sectData = [];

  @observable activeSectIndex = 0;

  onChangeSectIndex = index => {
    this.activeSectIndex = index;
    this.sectSwiperStore.activeIndex = index;
  };

  sectSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChangeTransitionEnd: () => {
          this.onChangeSectIndex(this.sectSwiperStore.activeIndex);
        },
        click: event => {
          if (event?.target?.dataset?.id === 'sectVideo' && event.target.dataset.videoUrl) {
            this.openVideoModal(event.target.dataset.videoUrl);
          }
        }
      }
    }
  });

  // 获取门派介绍信息
  getSectInfo = async () => {
    try {
      const res = await getOmniData(Ids.sect.channel, [{ dataSourceId: Ids.sect.dataSources.ds_id || '' }]);
      const items = getRecordList(res?.[Ids.sect.dataSources.ds_id]?.result?.items);
      // 按 weight 降序排序
      const sortedItems = [...items].sort((a, b) => (b.weight || 0) - (a.weight || 0));
      this.sectData = sortedItems.map(item => ({
        name: item.title || '',
        role: getMediaUrl(item.bg_img),
        title: getMediaUrl(item.title_img),
        parameter: getMediaUrl(item.stats_radar_chart),
        positioning: getMediaUrl(item.range_type),
        weapon: getMediaUrl(item.weapon_illustration),
        tab: getMediaUrl(item.carousel_icon_unselected),
        activeTab: getMediaUrl(item.carousel_icon_selected),
        video: getMediaUrl(item.click_video)
      }));
    } catch (error) {
      console.log(error);
    }
  };

  /** 打开视频弹窗 */
  openVideoModal = videlUrl => {
    videlUrl && Video.append({ src: videlUrl });
  };
  use() {
    super.use();
    useMount(() => {
      this.getSectInfo();
    });
  }
}

export default Part3Store;
